module.exports = __webpack_public_path__ + "img/media_5.03e7f597.png";